module.exports = __webpack_public_path__ + "static/media/edit-table.e1fb4f52.svg";